import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';

import App from './components/App';
import whiteLabel from './lib/whiteLabel'

whiteLabel.getWhiteLabelData().init().then(function () {
  document.body.removeChild(document.querySelector('#app-loading-message'))
  ReactDOM.render(
    <App />,
    document.getElementById('root')
  )
})



// WEBPACK FOOTER //
// ./src/index.js